import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {dialogStyles} from '../dialog'
import {dialogTitleStyles} from '../dialog-title'
import {dialogContentStyles} from '../dialog-content'
import {dialogActionsStyles} from '../dialog-actions'
import {buttonStyles} from '../../buttons/button'
import {SimpleDialog as RmwcSimpleDialog} from '@rmwc/dialog'
import '@rmwc/dialog/styles'

const StyledRmwcSimpleDialog = styled(RmwcSimpleDialog)`
  ${dialogStyles({selector: '&&&'})}
  ${dialogTitleStyles({selector: '&&& .mdc-dialog__title'})}
  ${dialogContentStyles({selector: '&&& .mdc-dialog__content'})}
  ${dialogActionsStyles({selector: '&&& .mdc-dialog__actions'})}
  ${buttonStyles({selector: '&&& .mdc-dialog__button'})}
  /* Unelevated button styles */
  &&& .mdc-dialog__button {
    --mdc-ripple-fg-opacity: 0.24;
  }
  /* Unelevated primary2 theme button styles */
  &&& .mdc-dialog__button {
    background-color: var(--mdc-theme-primary2);
    color: var(--mdc-theme-on-primary2);
  }
`

const SimpleDialog = ({children, ...otherProps}) => {
  return <StyledRmwcSimpleDialog {...otherProps}>{children}</StyledRmwcSimpleDialog>
}

SimpleDialog.propTypes = {
  acceptLabel: PropTypes.any,
  body: PropTypes.any,
  cancelLabel: PropTypes.any,
  children: PropTypes.any,
  footer: PropTypes.any,
  header: PropTypes.any,
  onClose: PropTypes.func,
  onClosed: PropTypes.func,
  onOpen: PropTypes.func,
  onOpened: PropTypes.func,
  open: PropTypes.bool,
  preventOutsideDismiss: PropTypes.bool,
  title: PropTypes.any
}

export {SimpleDialog}
